import React, { Fragment } from 'react';

import HiddenDiv from 'components/core/HiddenDiv.component';
import GenericErrorPanel from 'components/generic/GenericErrorPanel.component';
import useGlobalMessages from 'hooks/useGlobalMessages.hook';
import isNotFullArray from 'utils/predicates/array/isNotFullArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './UserMessages.module.scss';

const TextWithNewLines = ({ value }) =>
  value.split('\n').map((line, index) => (
    <Fragment key={createNodeKey({ index, tag: 'line' })}>
      {line}
      <br />
      <br />
    </Fragment>
  ));

const UserMessages = () => {
  const { clear, metaAndData } = useGlobalMessages();

  if (isNotFullArray(metaAndData)) return <HiddenDiv tag="UserMessages--hidden" />;

  return (
    <div data-bem="UserMessages" className={CN.component}>
      <GenericErrorPanel tag="UserMessages__panel" onClose={clear}>
        {metaAndData.map((item, index) => (
          <div
            data-bem="UserMessages__item"
            key={createNodeKey({ index, tag: 'message' })}
            data-umsg-level={String(item?.meta?.level)}
            data-umsg-atag={String(item?.meta?.atag)}
            data-umsg-mtag={String(item?.meta?.mtag)}
            data-umsg-status={String(item?.meta?.status)}
          >
            <TextWithNewLines value={item?.data} />
          </div>
        ))}
      </GenericErrorPanel>
    </div>
  );
};

export default UserMessages;
